/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Tags from "./Tags";
import GetItem from "../../../helpers/dataProviders/getItem";
import parseAppKey from "../../../helpers/routeHelpers/parseAppKey";
import PostItem from "../../../helpers/dataProviders/postItem";

class TopicsPicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			values: [],
		};
		this.appKey = parseAppKey();
	}

	componentDidMount() {
		this.getTopics();
	}

	getTopics = () => {
		GetItem(`/apps/${this.appKey}/topics`).then(data => {
			let values = [];
			data.data.forEach(topic => {
				values.push({
					id: topic.id,
					label: `${topic.name} (${topic.recipientCount})`,
				});
			});
			const { experiences } = this.props;
			if (experiences && experiences.length) {
				experiences.forEach(exp => {
					values.push({
						id: exp.id,
						label: `${exp.name} Experience (${exp.recipientCount})`,
					});
				});
			}
			this.setState({ values });
		});
	};

	handleAddition = tag => {
		let { apps } = this.props;
		if (apps) {
			let app = apps.find(app => app.key === this.appKey);
			if (app) {
				return PostItem("/topics", { name: tag.name, appId: app.id })
					.then(data => {
						this.getTopics();
						return { result: true, tag: { id: data.data.id, name: data.data.name } };
					})
					.catch(error => {
						let msg = "";
						if (error.response.data.Errors) {
							error.response.data.Errors.forEach(error => {
								msg += error.Value;
							});
						}
						return msg;
					});
			}
		}
		return "Your topic couldn't be added";
	};

	render(){
		const { max } = this.props;
		return (
			<div className="picker-input">
				{this.state.values && (
					<Tags
						{...this.props}
						max={max ? max : null}
						dataObjects={this.state.values}
						dataObjectKey="id"
						dataObjectLabel="label"
						minQueryLength={1}
						allowNew
						handleAddition={this.handleAddition}
					/>
				)}
			</div>
		);
	}
}

TopicsPicker.propTypes = {
	fieldState: PropTypes.object,
	fieldApi: PropTypes.object,
	dataObjects: PropTypes.array,
	dataObjectKey: PropTypes.string,
	dataObjectLabel: PropTypes.string,
	allowNew: PropTypes.bool,
	placeholder: PropTypes.string,
	tagInstructions: PropTypes.string,
	apps: PropTypes.array,
	experiences: PropTypes.array,
	max: PropTypes.number,
	isRequired: PropTypes.bool,
};

const mapStateToProps = state => ({
	apps: state.apps.apps,
	experiences: state.experiences.experiences,
});

export default connect(mapStateToProps)(TopicsPicker);
